
import { Component, Vue } from "vue-property-decorator"
import { XinWbApproveOperateEmployeePass,XinWbApproveOperateEmployeeReason,XinWbApproveOperateEmployeeUrge } from '@xin/xin-workbench'

@Component({
  name: "ApproveOperateMixin",
  components:{
    XinWbApproveOperateEmployeePass,
    XinWbApproveOperateEmployeeReason,
    XinWbApproveOperateEmployeeUrge,
  }
})
export default class ApproveOperateMixin extends Vue {

  //审批卡片操作
  approveOperate(operateKey:string,data:any){
    const {signStatus,flowTypeId,stepNodeId,processId,sidStr,skipPassConfirm} = data
    let operateData = {}

    switch(operateKey){
      case 'transmit': //审批-转发
      case 'cancel': //审批-撤销
        operateData = {
          operationType:operateKey,
          visible:true,
          sid:sidStr,
          signStatus,
          stepIds:stepNodeId,
          entrance:true
        }
        //@ts-ignore
        this.$refs.approveOperateReasonRef.open(operateData)
        break;
      case 'reject': //审批-驳回
      case 'approve': //审批-通过
        operateData = {
          operationType:operateKey,
          visible:true,
          isOld: 0, //是否老审批
          signStatus,
          skipPassConfirm,
          isShowDismissConfirmDate: operateKey=='approve'&&flowTypeId==11,//是否显示离职确认时间 通过操作且是离职审批
          stepIds:stepNodeId,
          processId,
          sid:sidStr,
          entrance:true
        }
        //@ts-ignore
        this.$refs.approveOperatePassRef.open(operateData)
        break;
      case 'urge': //审批-催办
        operateData = {
          visible:true,
          testUrlParams:true,
          ajaxParams:{
            sid:sidStr
          },
          entrance:true
        }
        //@ts-ignore
        this.$refs.approveOperateUrgeRef.open(operateData)
        break;
      default:
        break
    }
  }

}
